import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import BankAccountAddForm from "../../components/BankAccount/Add/BankAccountAddForm";
import { routerLinks } from "../../hoc/Router/routerLinks";
import { BANK_ACCOUNT_ADD } from "../../hoc/Router/routerTypes";

const BankAccountAddPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "افزودن حساب بانکی ",
            to: routerLinks(BANK_ACCOUNT_ADD),
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <BankAccountAddForm />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default BankAccountAddPage;
